export const nbrInscrits = {
                "Utopix": [
                    {
                        "name": "2024",
                        "monthly_premium": 26,
                        "yearly_premium": 165,
                        "formations": 0,
                        "cycles": 0,
                        "saisons": 0,
                        "congrès": 0,
                        "cycles_essential": 0,
                        "renewals": 0
                    },
                    {
                        "name": "2025",
                        "monthly_premium": 10,
                        "yearly_premium": 5,
                        "formations": 0,
                        "cycles": 0,
                        "saisons": 0,
                        "congrès": 0,
                        "cycles_essential": 0,
                        "renewals": 0
                    }
                ],
                "KA": [
                    {
                        "name": "2025",
                        "monthly_premium": 10,
                        "yearly_premium": 5,
                        "formations": 0,
                        "cycles": 0,
                        "saisons": 0,
                        "congrès": 0,
                        "cycles_essential": 0,
                        "renewals": 0
                    }
                ],
                "Lexalert": [],
};


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/data.js